


























































import {
  PRODUCT_ALLOCATED_PENSION_CASH,
  PRODUCT_ALLOCATED_PENSION_FIXED,
  PRODUCT_ANNUITY_FIXED_TERM,
  PRODUCT_ANNUITY_LIQUID_LIFETIME,
  PRODUCT_ANNUITY_LIFETIME,
  PRODUCT_TERM_ALLOCATED_PENSION_CASH,
  PRODUCT_TERM_ALLOCATED_PENSION_FIXED,
} from '../../utils/fieldMappers/constants';
export default {
  name: 'BankDetails',
  components: {},
  props: ['data'],
  data() {
    return {
      accountTypesPaidByCheque: [
        PRODUCT_ALLOCATED_PENSION_CASH,
        PRODUCT_ALLOCATED_PENSION_FIXED,
        PRODUCT_ANNUITY_FIXED_TERM,
        PRODUCT_ANNUITY_LIQUID_LIFETIME,
        PRODUCT_ANNUITY_LIFETIME,
        PRODUCT_TERM_ALLOCATED_PENSION_CASH,
        PRODUCT_TERM_ALLOCATED_PENSION_FIXED,
      ],
    };
  },
  computed: {
    noDetails() {
      return !this.data.investment.bankDetails.length || this.data.investment.bankDetails === null;
    },
    autoCashAccountToShow() {
      const val =
        this.data.investment.bankDetails.filter((item) => {
          return item.bankType === 'Auto Cash';
        })[0] || null;

      return val;
    },
    paidByCheque() {
      if (
        !this.autoCashAccountToShow &&
        this.data.investment.bankDetails[0].bankType === 'Cheque' &&
        this.accountTypesPaidByCheque.includes(this.data.investment.accountProductType)
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {},
};
